module.exports = __webpack_public_path__ + "img/success.35ffbfe2.png";